import { LocationContext } from '../core/history'
import { useContext } from 'react'

export function useLocation() {
  return useContext(LocationContext)
}
